/** 通用tabbar配置 */
export const commonTabBar = [
  {
    pagePath: 'pages/home/index',
    iconPath: 'static/tabbar/home.png',
    selectedIconPath: 'static/tabbar/home_active.png',
    text: '首页',
  },
  {
    pagePath: 'pages/classify/index',
    iconPath: 'static/tabbar/group.png',
    selectedIconPath: 'static/tabbar/group_active.png',
    text: '所有商品',
  },
  {
    pagePath: 'pages/member/index',
    iconPath: 'static/tabbar/member.png',
    selectedIconPath: 'static/tabbar/member_active.png',
    text: '会员中心',
  },
  {
    pagePath: 'pages/cart/index',
    iconPath: 'static/tabbar/cart.png',
    selectedIconPath: 'static/tabbar/cart_active.png',
    text: '购物车',
  },
  {
    pagePath: 'pages/self/index',
    iconPath: 'static/tabbar/user.png',
    selectedIconPath: 'static/tabbar/user_active.png',
    text: '我的',
  },
];

/** 探虎tabbar配置 */
export const tanhuTabbar = [
  {
    pagePath: 'pages/home/index',
    iconPath: 'static/tabbar/home.png',
    selectedIconPath: 'static/tabbar/home_active.png',
    text: '首页',
  },
  {
    pagePath: 'pages/classify/index',
    iconPath: 'static/tabbar/group.png',
    selectedIconPath: 'static/tabbar/group_active.png',
    text: '所有商品',
  },
  {
    pagePath: 'pages/self/index',
    iconPath: 'static/tabbar/user.png',
    selectedIconPath: 'static/tabbar/user_active.png',
    text: '我的',
  },
];
